import React from 'react';
import { DestinationsResponse, GeographyApi } from '@model/iceberg';
import { TripTypes } from '@model/contentful';
import { DestinationPageHolidaysLayout, DestinationPageHolidaysLayoutProps } from '@layout/DestinationPageLayout';
import { getStaticPropsDestinations } from '@layout/get-page-props';
import { storeWrapper } from '@state/store';
import { withGlobalProvider } from 'providers/globalProvider';
import { GetStaticProps } from 'next';
import { DestinationLevel, getDestinationStaticPaths } from '@util/get-destination-static-paths';
import { DestinationPage } from '@model/common/pages/DestinationPage';
import { Revalidate } from '@model/config/revalidate';

const DestinationCountryPageHolidays = (props: DestinationPageHolidaysLayoutProps) => {
  return <DestinationPageHolidaysLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ res, params }: any) => ({
  ...(await getStaticPropsDestinations({ store, res, query: params, tripType: TripTypes.HOLIDAYS })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const destinations: DestinationsResponse = await new GeographyApi().getDestinations();
  const paths = getDestinationStaticPaths(
    destinations.destinations,
    DestinationLevel.COUNTRY,
    DestinationPage.HOLIDAYS
  );
  return { paths, fallback: false };
}

export default withGlobalProvider(DestinationCountryPageHolidays);
